// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"0747032e","592":"b2996ae2","856":"42fbb4d2"}[chunkId] + ".chunk.js";
};